import { useEffect, useRef } from 'react';
import { useDeviceType } from '~/context/common/DeviceContext';

export default function useModalScrollRestoration(isAnyModalOpen: boolean) {
  const scrollPositionRef = useRef<number>(undefined);
  const { isDesktop } = useDeviceType();

  // .no-scroll class doesn't prevent body scrolling on some mobile devices
  // so we need to manually save and restore scroll position
  useEffect(() => {
    if (isDesktop) return;

    if (isAnyModalOpen) {
      scrollPositionRef.current = window.scrollY;
    } else if (scrollPositionRef.current !== undefined) {
      if (scrollPositionRef.current !== window.scrollY) {
        window.scrollTo({
          top: scrollPositionRef.current,
          behavior: 'instant'
        });
      }
      scrollPositionRef.current = undefined;
    }
  }, [isAnyModalOpen, isDesktop]);
}
